import api from '@js/actions/api';

export const sendReview = (reviewData) => (
    api.post('/api/v1/reviews', {
        review: {
            ...reviewData
        }
    })
);
